import { useNavigate } from 'react-router-dom'
import { t } from '../../i18n/translations'

/**
 * Footer - legal links shown at the bottom of every page.
 * Renders Terms of Service and Privacy Policy links (in addition to the
 * existing links in Settings) plus a small brand line.
 */
export default function Footer() {
  const navigate = useNavigate()

  return (
    <footer className="mt-8 pt-4 pb-2 border-t border-gray-200 text-center">
      <nav className="flex items-center justify-center gap-3 text-xs text-gray-500 flex-wrap">
        <button
          onClick={() => navigate('/page/terms-of-service')}
          className="hover:text-gray-700 transition-colors underline-offset-2 hover:underline"
        >
          {t('legal.termsOfService')}
        </button>
        <span className="text-gray-300">·</span>
        <button
          onClick={() => navigate('/page/privacy-policy')}
          className="hover:text-gray-700 transition-colors underline-offset-2 hover:underline"
        >
          {t('legal.privacyPolicy')}
        </button>
      </nav>
      <p className="mt-2 text-[11px] text-gray-400">
        © {t('footer.rights')}
      </p>
    </footer>
  )
}
